import router from '@/router'; 
import axios from 'axios';



export default {
  navigateTo(routeToNavigate) {
    router.push(routeToNavigate);
  },
  
  async executeHttpPOSTRequest(httpRequestRoute, httpRequestQuery = {}){
    return new Promise((executeHttpPOSTRequestPromiseResolve) => {
      axios.post(`${process.env.VUE_APP_BACKEND_HTTPS_URL}${httpRequestRoute}`, httpRequestQuery).then((httpResponse) => {
        executeHttpPOSTRequestPromiseResolve(httpResponse.data);
      })
      .catch((error) => {
        const result = error.response?.data?.result || error;
        executeHttpPOSTRequestPromiseResolve({success: false, result: result});            
      });
    });
  },

  playSound(soundName, soundVolumeLevel){
    console.log(soundVolumeLevel)
    if (!document.body.hasAttribute('data-user-interacted')) return;
    const sound = new Audio(require(`@/assets/sounds/${soundName}.mp3`));
    sound.volume = 100 / 100;
    sound.play();
  },

  

  copyToClipboard(vueInstance, variableTitle, variableTitleType, variableValue){
    navigator.clipboard.writeText(variableValue ? `${variableTitle}: ${variableValue}` : window.location.href).then(() => {
      vueInstance.$root.notificationDialog.showSystemNotificationDialog('copyToClipboard_success', 'success', `${variableTitle} copiad${variableTitleType} al portapapeles`, null, false);
    }).catch(() => {
      vueInstance.$root.notificationDialog.showSystemNotificationDialog('copyToClipboard_error', 'error', `Ha ocurrido un error inesperado al copiar ${variableTitleType == 'a' ? 'la' : 'el'} ${variableTitle.toLowerCase()} al portapapeles, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, false);
    });
  },

  copyToClipboardWithoutTitle(vueInstance, variableTitle, variableTitleType, variableValue){
    navigator.clipboard.writeText(variableValue ? variableValue : window.location.href).then(() => {
      vueInstance.$root.notificationDialog.showSystemNotificationDialog('copyToClipboard_success', 'success', `${variableTitle} copiad${variableTitleType} al portapapeles`, null, false);
    }).catch(() => {
      vueInstance.$root.notificationDialog.showSystemNotificationDialog('copyToClipboard_error', 'error', `Ha ocurrido un error inesperado al copiar al portapapeles, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, false);
    });
  },

  blurInput(vueInstance, inputReference){
    const blurInputInterval = setInterval(() => {
      if (vueInstance.$refs[inputReference]) {
        vueInstance.$refs[inputReference].blur();
        clearInterval(blurInputInterval);
      }
    }, 100);
  },

  focusInput(vueInstance, inputReference){
    let maxAttempts = 30;
    const focusInputInterval = setInterval(() => {
      if (maxAttempts > 0) maxAttempts--;
      else {
        clearInterval(focusInputInterval);
      }
      if (vueInstance.$refs[inputReference]) {
        vueInstance.$refs[inputReference].focus();
        clearInterval(focusInputInterval);
      }
    }, 100);
  },

  allowOnlyNumberOnInput(allowOnlyNumberOnInputEvent){
    if (!/^[0-9]$/.test(String.fromCharCode(allowOnlyNumberOnInputEvent.keyCode || allowOnlyNumberOnInputEvent.which))){
      allowOnlyNumberOnInputEvent.preventDefault();
    }
  },

  allowOnlyNumberOnInputWithDecimal(allowOnlyNumberOnInputWithDecimalEvent){
    if (!/^[0-9.]$/.test(String.fromCharCode(allowOnlyNumberOnInputWithDecimalEvent.keyCode || allowOnlyNumberOnInputWithDecimalEvent.which))){
      allowOnlyNumberOnInputWithDecimalEvent.preventDefault();
    }
  },

  allowOnlyValidLatitudeLongitudeOnInput(allowOnlyValidLatitudeLongitudeOnInputEvent){
    if (!/^[0-9.-]$/.test(String.fromCharCode(allowOnlyValidLatitudeLongitudeOnInputEvent.keyCode || allowOnlyValidLatitudeLongitudeOnInputEvent.which))){
      allowOnlyValidLatitudeLongitudeOnInputEvent.preventDefault();
    }
  },

  fromHexToRGBA(hexColor, opacity) {
    return 'rgba(' + parseInt(hexColor.slice(1, 3), 16) + ', ' + parseInt(hexColor.slice(3, 5), 16) + ', ' + parseInt(hexColor.slice(5, 7), 16) + ', ' + opacity + ')';
  },

  normalizeURL(url) {
    if (!url) return '#';
    if (/^https?:\/\//i.test(url)) return url;
    return `https://${url}`;
  }

}